import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, PrimaryButton } from './ui/UI';
const shipping = ['LLM-powered products', 'Internal copilots', 'Customer-support bots', 'RAG systems', 'AI agents', 'Workflow automations', 'AI-enabled SaaS features', 'Developer assistants', 'Knowledge-base chatbots'];
const risks = ['Prompt injection', 'Sensitive data leakage', 'RAG authorization failure', 'Unsafe tool invocation', 'Agent over-permissioning', 'System prompt exposure', 'Guardrail drift', 'Cross-tenant data exposure', 'Customer-security-review gaps', 'Unverified AI safety controls'];
const questions = ['Can our AI app leak sensitive data?', 'Can prompt injection bypass instructions?', 'Can a RAG system retrieve data a user should not access?', 'Can an agent call tools it should not use?', 'Are our AI guardrails still working?', 'Can we prove our AI app was tested?', 'Can we produce evidence for customer security reviews?'];
export function AISecurityValidation() {
  return <section id="ai-security" className="relative w-full py-32 border-t border-white/5" data-id="element-76">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-77">
        <SectionLabel number="10" label="AI Security Validation" className="mb-8" data-id="element-78" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-79">
          <div className="lg:col-span-8" data-id="element-80">
            <SectionHeading size="xl" data-id="element-81">
              AI apps are now part of
              <br data-id="element-82" />
              <span className="text-white/40" data-id="element-83">the attack surface.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-4 lg:pt-4" data-id="element-84">
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-85">
              Validate your AI app before customers, attackers, or auditors do.
              Periscan turns AI-security validation into practical evidence.
            </p>
          </div>
        </div>

        {/* Shipping + Risks columns */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/5 mb-12" data-id="element-86">
          {/* Shipping */}
          <div className="bg-[#070a0e] p-8 md:p-10" data-id="element-87">
            <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-6" data-id="element-88">
              Modern companies ship
            </p>
            <div className="space-y-3" data-id="element-89">
              {shipping.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: i * 0.04
            }} className="flex items-center gap-3 py-1.5" data-id="element-90">
                  <span className="font-mono text-xs text-white/30" data-id="element-91">→</span>
                  <span className="text-base text-white/80" data-id="element-92">{item}</span>
                </motion.div>)}
            </div>
          </div>

          {/* Risks */}
          <div className="bg-[#070a0e] p-8 md:p-10 relative overflow-hidden" data-id="element-93">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#1a8fd4]/5 blur-[100px] rounded-full pointer-events-none" data-id="element-94" />
            <p className="font-mono text-xs uppercase tracking-widest text-[#1a8fd4] mb-6 relative" data-id="element-95">
              These create new risks
            </p>
            <div className="space-y-3 relative" data-id="element-96">
              {risks.map((risk, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: i * 0.04
            }} className="flex items-center gap-3 py-1.5" data-id="element-97">
                  <span className="w-1 h-1 rounded-full bg-[#1a8fd4]" data-id="element-98" />
                  <span className="text-base text-white" data-id="element-99">{risk}</span>
                </motion.div>)}
            </div>
          </div>
        </div>

        {/* Questions Periscan answers */}
        <div className="rounded-2xl bg-gradient-to-br from-[#0a0d12] to-[#070a0e] border border-white/5 p-8 md:p-12 mb-10" data-id="element-100">
          <p className="font-mono text-xs uppercase tracking-widest text-[#1a8fd4] mb-8" data-id="element-101">
            Questions Periscan AI Security Validation answers
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4" data-id="element-102">
            {questions.map((q, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.05
          }} className="flex items-start gap-3" data-id="element-103">
                <span className="font-mono text-xs text-[#1a8fd4]/60 mt-1.5" data-id="element-104">
                  ?
                </span>
                <span className="text-base text-white/80" data-id="element-105">{q}</span>
              </motion.div>)}
          </div>
        </div>

        <PrimaryButton href="#early-access" size="lg" data-id="element-106">
          Join the AI App Validation Beta
        </PrimaryButton>
      </div>
    </section>;
}